import ProxyInternal from './ProxyInternal';

export default ProxyInternal;